// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dnd__Types from "./Dnd__Types.bs.js";
import * as Dnd__DndContext from "./Dnd__DndContext.bs.js";
import * as Dnd__DndManager from "./Dnd__DndManager.bs.js";
import * as Dnd__DraggableItem from "./Dnd__DraggableItem.bs.js";
import * as Dnd__DroppableContainer from "./Dnd__DroppableContainer.bs.js";

function Make(Item, Container) {
  var DndContext = Dnd__DndContext.Make(Item, Container);
  var DndManager = Dnd__DndManager.Make({
        Item: DndContext.Item,
        Container: DndContext.Container,
        x: DndContext.x,
        useDnd: DndContext.useDnd,
        Provider: DndContext.Provider
      });
  var DraggableItem = Dnd__DraggableItem.Make({
        Item: DndContext.Item,
        Container: DndContext.Container,
        x: DndContext.x,
        useDnd: DndContext.useDnd,
        Provider: DndContext.Provider
      });
  var DroppableContainer = Dnd__DroppableContainer.Make({
        Item: DndContext.Item,
        Container: DndContext.Container,
        x: DndContext.x,
        useDnd: DndContext.useDnd,
        Provider: DndContext.Provider
      });
  return {
          DndContext: DndContext,
          DndManager: DndManager,
          DraggableItem: DraggableItem,
          DroppableContainer: DroppableContainer
        };
}

function MakeSingletonContainer($star) {
  var eq = function (param, param$1) {
    return true;
  };
  var cmp = function (param, param$1) {
    return 0;
  };
  return {
          eq: eq,
          cmp: cmp
        };
}

var $$Selection = {
  Make: undefined
};

var Point = Dnd__Types.Point;

var Delta = Dnd__Types.Delta;

var Distance = Dnd__Types.Distance;

var Dimensions = Dnd__Types.Dimensions;

var Rect = Dnd__Types.Rect;

var Margins = Dnd__Types.Margins;

var Borders = Dnd__Types.Borders;

var Paddings = Dnd__Types.Paddings;

var Offset = Dnd__Types.Offset;

var Scroll = Dnd__Types.Scroll;

var CanScroll = Dnd__Types.CanScroll;

var Axis = Dnd__Types.Axis;

var Arrow = Dnd__Types.Arrow;

var Direction = Dnd__Types.Direction;

var AxisDirection = Dnd__Types.AxisDirection;

var RelativityBag = Dnd__Types.RelativityBag;

var Geometry = Dnd__Types.Geometry;

var Shift = Dnd__Types.Shift;

var ScrollableElement = Dnd__Types.ScrollableElement;

var ItemBag = Dnd__Types.ItemBag;

var ContainerBag = Dnd__Types.ContainerBag;

var Ghost = Dnd__Types.Ghost;

var Pawn = Dnd__Types.Pawn;

var Subscriptions = Dnd__Types.Subscriptions;

var ReorderResult = Dnd__Types.ReorderResult;

var Status = Dnd__Types.Status;

export {
  Point ,
  Delta ,
  Distance ,
  Dimensions ,
  Rect ,
  Margins ,
  Borders ,
  Paddings ,
  Offset ,
  Scroll ,
  CanScroll ,
  Axis ,
  Arrow ,
  Direction ,
  AxisDirection ,
  RelativityBag ,
  Geometry ,
  Shift ,
  ScrollableElement ,
  ItemBag ,
  ContainerBag ,
  Ghost ,
  Pawn ,
  Subscriptions ,
  ReorderResult ,
  Status ,
  Make ,
  MakeSingletonContainer ,
  $$Selection ,
  
}
/* Dnd__DndContext Not a pure module */
